var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cs-preloader-overlay',{attrs:{"loading":_vm.loading}},[(_vm.isProjectLoaded)?[(_vm.hasMarketplaceBills)?_c('marketplace-bills',{attrs:{"project":_vm.PROJECT},on:{"donate":_vm.handlePaymentFormShown}}):_c('payment-amount',{attrs:{"project":_vm.PROJECT}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }